import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './common/LanguageSwitcher';
import './SchoolPage.css';

const PrimarySchoolPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('landing');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  // Primary School modules (Algerian curriculum) — names from i18n
  const moduleKeys = [
    { id: 'arabic', key: 'resources.subjects.arabic', icon: 'menu_book', color: '#1a73e8' },
    { id: 'mathematics', key: 'resources.subjects.mathematics', icon: 'calculate', color: '#34a853' },
    { id: 'french', key: 'resources.subjects.french', icon: 'translate', color: '#ea4335' },
    { id: 'science', key: 'resources.subjects.scienceTechnology', icon: 'science', color: '#fbbc04' },
    { id: 'islamic-education', key: 'resources.subjects.islamicEducation', icon: 'mosque', color: '#9c27b0' },
    { id: 'history-geography', key: 'resources.subjects.historyGeography', icon: 'public', color: '#ff9800' },
    { id: 'civic-education', key: 'resources.subjects.civicEducation', icon: 'account_balance', color: '#00bcd4' },
    { id: 'english', key: 'resources.subjects.english', icon: 'language', color: '#673ab7' }
  ];

  const handleModuleClick = (moduleId) => {
    navigate(`/resources/primary/${moduleId}`);
  };

  return (
    <div className="school-page">
      {/* Navigation Bar */}
      <nav className={`landing-navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">
          <div className="logo" onClick={() => navigate('/')}>
            <span className="material-icons">school</span>
            <span>Nativelike</span>
          </div>
          <div className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
            <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); setIsMobileMenuOpen(false); }}>{t('nav.features')}</a>
            <a href="#how-it-works" onClick={(e) => { e.preventDefault(); scrollToSection('how-it-works'); setIsMobileMenuOpen(false); }}>{t('nav.howItWorks')}</a>
            <a href="#pricing" onClick={(e) => { e.preventDefault(); scrollToSection('pricing'); setIsMobileMenuOpen(false); }}>{t('nav.pricing')}</a>
            <a href="#testimonials" onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); setIsMobileMenuOpen(false); }}>{t('nav.reviews')}</a>
            <a href="/resources" onClick={(e) => { e.preventDefault(); navigate('/resources'); setIsMobileMenuOpen(false); }} className="active">{t('nav.resources')}</a>
          </div>
          <div className="nav-actions">
            <LanguageSwitcher className="landing-language-switcher" />
            <button className="btn-login" onClick={() => scrollToSection('login')}>{t('nav.login')}</button>
            <button className="btn-primary" onClick={() => navigate('/signup')}>{t('nav.startLearning')}</button>
            <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
              <span className="material-icons">{isMobileMenuOpen ? 'close' : 'menu'}</span>
            </button>
          </div>
        </div>
      </nav>

      <div className="school-container" style={{ paddingTop: '80px' }}>
        {/* Breadcrumb */}
        <div className="breadcrumb">
          <a href="/resources" onClick={(e) => { e.preventDefault(); navigate('/resources'); }}>{t('nav.resources')}</a>
          <span className="material-icons">chevron_right</span>
          <span>{t('resources.primarySchool')}</span>
        </div>

        {/* Header */}
        <div className="school-header">
          <h1 className="school-title">
            <span className="material-icons">child_care</span>
            {t('resources.primarySchool')}
          </h1>
          <p className="school-subtitle">
            {t('resources.selectSubjectPrimary')}
          </p>
        </div>

        {/* Modules Grid */}
        <div className="modules-grid">
          {moduleKeys.map((module) => (
            <div
              key={module.id}
              className="module-card"
              onClick={() => handleModuleClick(module.id)}
            >
              <div className="module-icon" style={{ backgroundColor: `${module.color}15`, color: module.color }}>
                <span className="material-icons">{module.icon}</span>
              </div>
              <h3>{t(module.key)}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrimarySchoolPage;
